import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SupplierProduct, SupplierProductDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SupplierProductService extends TmsWebBaseEditCreateService<
  SupplierProductDetails,
  SupplierProductDetails
> {
  constructor() {
    super('SupplierProduct', $localize`Supplier Products`);
  }

  getForProduct(id: string): Observable<SupplierProduct[]> {
    return this.httpService.get<SupplierProduct[]>(`${this.apiUrl}/Product/${id}`);
  }

  getForStockEnquiryProduct(id: string): Observable<SupplierProduct[]> {
    return this.httpService.get<SupplierProduct[]>(`${this.apiUrl}/StockEnquiryProduct/${id}`);
  }
}
